module.exports = __webpack_public_path__ + "media/images/layouts/bean_bag-d0125734b00b4aa71b637647714cabc9.png";